import { render } from "./ProfDetail.vue?vue&type=template&id=03fb8970&scoped=true"
import script from "./ProfDetail.vue?vue&type=script&lang=js"
export * from "./ProfDetail.vue?vue&type=script&lang=js"

import "../assets/css/scheduleCommon.css?vue&type=style&index=0&lang=css&external"
import "./ProfDetail.vue?vue&type=style&index=1&id=03fb8970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fb8970"]])

export default __exports__